import * as util from '../apiUtils';
import * as common from '../apiCommon';
import { DOCTYPE_BUDGET } from '@krispsystems/constants';

const daysOrder = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export async function fetchBudget(app, params) {
  const { id } = params;
  const budget = await common.getDoc(app, { id, docType: DOCTYPE_BUDGET });

  const weeklySchedules = [];
  const exceptionSchedules = [];

  (budget.schedules || []).forEach((schedule) =>
    schedule.date
      ? exceptionSchedules.push(schedule)
      : weeklySchedules.push(schedule)
  );

  weeklySchedules.sort((a, b) => {
    return daysOrder.indexOf(a.day) - daysOrder.indexOf(b.day);
  });

  budget.weekly_schedules = weeklySchedules;
  budget.exception_schedules = exceptionSchedules;

  delete budget.schedules;
  return budget;
}

export function deleteBudget(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DOCTYPE_BUDGET,
  });
}

export function saveBudget(app, dataToSave) {
  const { user = {}, data } = dataToSave;
  const { exception_schedules, weekly_schedules } = data;

  const doc = {
    active: util.toBoolean(data.active),
    amount: data.amount || 0,
    comment: util.toStringText(data.comment),
    currency_id: util.toStringText(data.currency_id),
    doc_type: DOCTYPE_BUDGET,
    effective_from: util.toStringDate(data.effective_from),
    effective_to: util.toStringDate(data.effective_to),
    location_id: util.toStringText(data.location_id),
    name: util.toStringText(data.name),
    reason_code_id: util.toStringText(data.reason_code_id),
    schedule: util.toStringText(data.schedule),
    subsidiary_id: util.toStringText(data.subsidiary_id),
    type_id: util.toStringText(data.type_id),
    schedules: [
      ...weekly_schedules,
      ...exception_schedules,
    ],
  };

  return common.saveDoc(app, {
    doc,
    user,
    source: data,
  });
}
